export default function SectionTitleCenter(props) {
  return (
    <div
      className={`container mx-auto grid place-items-center mt-40 ${props.className}`}
    >
      <div className="min-w-0 text-center">
        <h2 className="text-4xl font-bold sm:truncate sm:tracking-tight">
          {props.sectionTitle}
        </h2>
        <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6 justify-center text-center">
          <div className="mt-2 flex items-center text-base">
            {props.sectionSubTitle}
          </div>
        </div>
      </div>
    </div>
  );
}
